import moment from 'moment';
import Vue from 'vue';

export const useFilters = () => {
  Vue.filter('formatDate', function(value) {
    if (value) {
      return moment(String(value)).format('DD/MM/YYYY hh:mm');
    }
  });
  Vue.filter('esDate', function(value) {
    if (value) {
      moment.locale('es');
      return moment(String(value)).format('D, MMMM YYYY');
    }
  });
  Vue.filter('esDatewName', function(value) {
    if (value) {
      moment.locale('es');
      return moment(String(value)).format('dddd, D MMMM YYYY');
    }
  });
  Vue.filter('enDate', function(value) {
    if (value) {
      moment.locale('en');
      return moment(String(value)).format('D, MMMM YYYY');
    }
  });
  Vue.filter('formatOnlyLatinDate', function(value) {
    if (value) {
      return moment(String(value)).format('DD/MM/YYYY');
    }
  });
  Vue.filter('striphtml', function(value) {
    var div = document.createElement('div');
    div.innerHTML = value;
    var text = div.textContent || div.innerText || '';
    return text;
  });
};
